import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/dialog";

/** Confirm moving a selection to Trash; everything stays restorable from Gallery → Trash. */
export function TrashSelectionDialog({
  open,
  count,
  skipped,
  busy,
  error,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  count: number;
  skipped: number;
  busy: boolean;
  error: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <Dialog
      open={open}
      onClose={busy ? () => undefined : onCancel}
      title={count > 1 ? `Move ${count} to Trash?` : "Move to Trash?"}
      className="max-w-md"
    >
      <div className="p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-studio-warning/15 text-studio-warning">
            <Trash2 className="h-5 w-5" />
          </div>
          <div>
            <p className="text-sm leading-6 text-studio-ink">
              {count > 1
                ? `These ${count} generations will move out of Gallery and can be restored later from Trash.`
                : "This generation will move out of Gallery and can be restored later from Trash."}
            </p>
            {skipped > 0 && (
              <p className="mt-2 text-xs text-studio-muted">
                {skipped} selected {skipped === 1 ? "generation belongs" : "generations belong"} to other members and will stay.
              </p>
            )}
          </div>
        </div>
        {error && (
          <p role="alert" className="mt-4 rounded-lg bg-studio-danger/10 px-3 py-2 text-xs text-studio-danger">
            {error}
          </p>
        )}
        <div className="mt-5 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <Button type="button" variant="secondary" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button type="button" variant="danger" loading={busy} onClick={onConfirm}>
            {count > 1 ? `Move ${count} to Trash` : "Move to Trash"}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
